import { constants } from 'day8-ui';
import { PACKAGES } from '../constants';
import { getSelectedDestination, getSelectedPackageData } from './week';

const { TYW_DESTINATION } = constants;

export const getRatingBadge = ratingId => {
  switch (ratingId) {
  case 1:
  case 'economy':
    return 'pill--economy';
  case 2:
  case 'classic':
    return 'pill--classic';
  case 3:
  case 'premium':
    return 'pill--premium';
  case 4:
  case 'luxury':
    return 'pill--luxury';
  case 'luxury+':
    return 'pill--luxury-plus';
  default:
    return 'pill--standard';
  }
};

export const getPackageColorVariable = ratingId => {
  switch (ratingId) {
  case PACKAGES.CLASSIC:
    return 'var(--color-classic)';
  case PACKAGES.CLASSIC_MONO:
    return 'var(--color-classic-mono)';
  case PACKAGES.PREMIUM:
    return 'var(--color-premium)';
  case PACKAGES.CLASSIC_CAT:
    return 'var(--color-classic-cat)';
  case PACKAGES.LUXURY:
    return 'var(--color-luxury)';
  case PACKAGES.PREMIUM_MONO:
    return 'var(--color-premium-mono)';
  case PACKAGES.LUXURY_PLUS:
    return 'var(--color-luxury-plus)';
  case PACKAGES.PREMIUM_CAT:
    return 'var(--color-premium-cat)';
  default:
    return 'var(--color-white)';
  }
};

export const getYachtLayoutSpots = (destinations, location, yacht, destinationIdArg, isCabinBooking = null, packageDataObj) => {
  const selectedDestination = destinations && location && getSelectedDestination(destinations, location);
  const destinationId = destinationIdArg || selectedDestination?.id;
  const packageData = packageDataObj || (destinations && location && getSelectedPackageData(destinations, location));
  const isCabin = isCabinBooking || location?.pathname.indexOf('/cabins') > -1;
  const isBviCnct = destinationId === TYW_DESTINATION.BVI_CNCT;
  const isGreeceBootcamp = destinationId === TYW_DESTINATION.GREECE_BOOTCAMP;
  const isYachtnik = [TYW_DESTINATION.YACHTNIK_CROATIA, TYW_DESTINATION.YACHTNIK_MART_ST_LUCIA].includes(destinationId);
  let doubleCabins;
  let bunkCabins;
  let saloonSpots;
  let skipperCabinSpots;
  if (yacht) {
    doubleCabins = yacht.boat.doubleCabins;
    bunkCabins = yacht.boat.bunkCabins;
    skipperCabinSpots = yacht.boat.skipperCabinSpots;
    saloonSpots = yacht.boat.saloonSpots;
  }
  if (packageData?.id === PACKAGES.CLASSIC) {
    doubleCabins = 4;
    bunkCabins = 0;
    skipperCabinSpots = 0;
    saloonSpots = 2;
    if (isBviCnct) {
      saloonSpots = 2;
    }
    if (isYachtnik) {
      bunkCabins = 1;
      skipperCabinSpots = 1;
    }
  }
  if (packageData?.id === PACKAGES.PREMIUM) {
    doubleCabins = 4;
    bunkCabins = 1;
    skipperCabinSpots = 1;
    saloonSpots = 1;
    if (isYachtnik) {
      doubleCabins = 4;
      bunkCabins = 0;
      skipperCabinSpots = 2;
      saloonSpots = 2;
    }
    if (isBviCnct) {
      saloonSpots = 0;
      bunkCabins = 0;
      skipperCabinSpots = 2;
    }
  }
  if (packageData?.id === PACKAGES.LUXURY) {
    doubleCabins = 4;
    bunkCabins = 0;
    skipperCabinSpots = 2;
    saloonSpots = 2;
    if (isCabin || isGreeceBootcamp) {
      saloonSpots = 0;
    }
    if (isBviCnct && !isCabin) {
      doubleCabins = 6;
      saloonSpots = 0;
    }
  }
  if (packageData?.id === PACKAGES.LUXURY_PLUS) {
    doubleCabins = 6;
    bunkCabins = 0;
    skipperCabinSpots = 2;
    saloonSpots = 0;
  }
  if (packageData?.id === PACKAGES.CLASSIC_MONO) {
    doubleCabins = 4;
    bunkCabins = 0;
    skipperCabinSpots = 0;
    saloonSpots = 1;
  }
  if (packageData?.id === PACKAGES.CLASSIC_CAT) {
    doubleCabins = 4;
    bunkCabins = 0;
    skipperCabinSpots = 2;
    saloonSpots = 2;
    if (isCabin) {
      saloonSpots = 0;
    }
  }
  if (packageData?.id === PACKAGES.PREMIUM_MONO) {
    doubleCabins = 4;
    bunkCabins = 1;
    skipperCabinSpots = 1;
    saloonSpots = 1;
    if (isCabin) {
      saloonSpots = 0;
      skipperCabinSpots = 0;
    }
  }
  if (packageData?.id === PACKAGES.PREMIUM_CAT) {
    doubleCabins = 4;
    bunkCabins = 0;
    skipperCabinSpots = 2;
    saloonSpots = 2;
    if (isCabin) {
      saloonSpots = 0;
    }
  }
  return ({
    doubleCabins,
    bunkCabins,
    saloonSpots,
    skipperCabinSpots
  });
};

export const getMaxCapacityForStandardYacht = (destinations, location, destinationIdArg, isCabin, packageDataObj) => {
  const {
    doubleCabins,
    bunkCabins,
    saloonSpots,
    skipperCabinSpots
  } = getYachtLayoutSpots(destinations, location, null, destinationIdArg, isCabin, packageDataObj);
  return (doubleCabins * 2) + (bunkCabins * 2) + (skipperCabinSpots) + saloonSpots;
};
